"use client";
import { useState } from "react";
import Link from "next/link";
import React from "react";
import Phone from "@/public/icon/phone1.svg";
import Mail from "@/public/icon/mail.svg";
import App from "@/public/icon/app.svg";
import Play from "@/public/icon/play.svg";
import One from "@/public/icon/one.svg";
import Wp from "@/public/icon/whatsappred.svg";
import Socials from "../Socials/Socials";
import Down from "@/public/icon/down.svg";
import Clock from "@/public/icon/cl.svg";
import baseQueries from "@/libs/provideBaseQueriesOnFilterUrl";

const Footer = ({
  setting,
  campaigns,
  special_brand_menus,
  menu_brands,
  headerMenu,
  gender,
  t,
}) => {
  const [currentYear] = useState(new Date().getFullYear());

  const [activeIndex, setActiveIndex] = useState(null);
  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [activeHeaderIndex, setActiveHeaderIndex] = useState(null);
  const [activeBrandIndex, setActiveBrandIndex] = useState(null);

  const handleHeaderClick = (index) => {
    setActiveHeaderIndex(activeHeaderIndex === index ? null : index);
  };

  const handleBrandClick = (index) => {
    setActiveBrandIndex(activeBrandIndex === index ? null : index);
  };
  return (
    <footer>
      <div className="footerTop">
        <div className="container">
          <Link href={`tel:${setting.number}`}>
            <Phone />
            <span>{setting.number}</span>
          </Link>
          <Link href={setting.wp_link} target="_blank">
            <Wp />
            <span>WhatsApp</span>
          </Link>
          <Link href={`mailto:${setting.email}`}>
            <Mail />
            <span>{setting.email}</span>
          </Link>
          <div>
            <Clock />
            <span>09:00 – 22:00</span>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="footerMiddle">
          <div>
            <span onClick={() => handleClick(-1)}>
              <Link href="/specials"> {t["title.menu.specialCollection"]}</Link>
              <Down className={activeIndex === -1 ? "active" : ""} />
            </span>

            <ul className={activeIndex === -1 ? "active" : ""}>
              {special_brand_menus?.map((item) => (
                <li key={item.id}>
                  <Link href={`${item.alias}&${baseQueries.toString()}`}>
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          {headerMenu.map((item, index) => (
            <div key={index}>
              <span onClick={() => handleClick(index)}>
                <Link href={`${item.path}`}>{item.title}</Link>
                {item?.sub_menus ? (
                  <Down className={activeIndex === index ? "active" : ""} />
                ) : null}
              </span>
              <ul className={activeIndex === index ? "active" : ""}>
                {item?.sub_menus?.map((sub, i) => (
                  <li key={i}>
                    <Link href={`/${sub.path}`}>{sub.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          {menu_brands.map((item, index) => (
            <div key={index}>
              <span onClick={() => handleClick(index + 100)}>
                <Link href={`${item.alias}&${baseQueries.toString()}`}>
                  {item.title}
                </Link>
                {item?.sub_menu ? (
                  <Down
                    className={activeIndex === index + 100 ? "active" : ""}
                  />
                ) : null}
              </span>
              <ul className={activeIndex === index + 100 ? "active" : ""}>
                {item?.sub_menu?.map((sub, i) => (
                  <li key={i}>
                    <Link href={`${sub.alias}&${baseQueries.toString()}`}>
                      {sub.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          {/* {campaigns.map((item, index) => (
            <div key={index}>
              <span onClick={() => handleClick(index)}>
                <Link href={`${item.alias}&${baseQueries.toString()}`}>
                  {item.title}
                </Link>
              </span>
            </div>
          ))} */}
        </div>
      </div>
      <div className="footerSocials">
        <div className="container">
          <div className="footerSocialsLeft">
            <span>{t["download.ourapp"]}:</span>
            <Link href={setting.app_store_link} target="_blank">
              <App />
            </Link>
            <Link href={setting.play_store_link} target="_blank">
              <Play />
            </Link>
          </div>
          <Socials setting={setting} />
        </div>
      </div>
      <div className="container">
        <div className="footerBottom">
          <p>
            {currentYear}
            &reg; {t["all.rights"]} İyde Perfumery
          </p>
          <ul>
            <li>
              <Link href="/support/privacy-policy">{t["privacy.policy"]}</Link>
            </li>
          </ul>
          <div>
            Made by -
            <Link href="https://one.az/" target="_blank">
              <One />
              ONE STUDIO
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
